// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1sHoS","alert":"SettungsInbox_alert__3PIwq"};